import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
// import { useTranslation } from 'next-i18next';
// import PropTypes from 'prop-types';
import styles from './WhoWeAreHero.module.scss';

const WhoWeAreHero = ({ title, preamble, titleTop, titleBottom, companyStructureTagline }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const rootClasses = classNames(styles['Root']);

    const titleClasses = classNames(styles['Title'], 'grid', { [styles['Visible']]: isVisible });
    const titleMobileClasses = classNames(styles['TitleMobile'], {
        [styles['Visible']]: isVisible,
    });
    const contentClasses = classNames(styles['Content'], 'grid', {
        [styles['Visible']]: isVisible,
    });
    const taglineClasses = classNames(styles['Tagline'], 'grid', {
        [styles['Visible']]: isVisible,
    });

    return (
        <div className={rootClasses}>
            <h1 className={taglineClasses}>
                <span className={styles['TaglineText']}>{title}</span>
            </h1>
            <div className={titleMobileClasses}>
                <div className={titleClasses}>
                    <span className={styles['TitleContainer']}>
                        <span className={styles['TitleTop']}>{titleTop}</span>{' '}
                        <span className={styles['TitleBottom']}>{titleBottom}</span>
                    </span>
                </div>
            </div>
            <div className={styles['TitleDesktop']}>
                <span className={titleClasses}>
                    <span className={styles['TitleTop']}>{titleTop}</span>
                    <span className={styles['TitleBottom']}>{titleBottom}</span>
                </span>
            </div>
            <div className={contentClasses}>
                <p className={styles['Text']}>{preamble}</p>
            </div>
            <div className={`${styles['ImageGrid']} grid`}>
                <div className={styles['ImageContainer']}>
                    <img src={`/img/stadshuset.png`} legacy alt="An Image of Stadshuset" />
                </div>

                {/*<CompanyStructure companyStructureTagline={companyStructureTagline} />*/}
            </div>
        </div>
    );
};

WhoWeAreHero.propTypes = {};

const CompanyStructure = ({ companyStructureTagline }) => {
    return (
        <div className={styles['CompanyStructure']}>
            <div className={`${styles['BottomTagline']}`}>{companyStructureTagline}</div>
            <div className={styles['Sbr']}>
                <span>
                    <span>Stockholm</span> <span className={styles['Inline']}>Business Region AB</span>
                </span>
            </div>
            <div className={styles['Lines']}>
                <div className={styles['Line']}></div>
                <div className={styles['Line']}></div>
            </div>
            <div className={styles['Lines']}>
                <div className={styles['Invest']}>Invest Stockholm Business Region AB</div>
                <div className={styles['Visit']}>Visit Stockholm AB</div>
            </div>
        </div>
    );
};
export default WhoWeAreHero;
